import { togglePublishedAddress } from './personal-info-slice';

export const resetPendingData = (dispatch, appName: string) => {
	dispatch(togglePublishedAddress(false,
		null,
        null,
        appName,
	));

};